import { render, staticRenderFns } from "./ItemsNC.vue?vue&type=template&id=71f8d67a&"
import script from "./ItemsNC.vue?vue&type=script&lang=js&"
export * from "./ItemsNC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports